export enum AppStorageIdEnum {
    'AMAGNO' = 'amagno',
    'AKITA_MIMIC' = 'akita_mimic',
}
